export const pageWrapperStyle = {
  paddingTop: '80px',
  backgroundColor: 'var(--background-color)',
  backgroundImage: 'none',
  minHeight: '100vh',
};
